package com.shadowings.gero.util

import androidx.compose.runtime.Composable
import androidx.compose.ui.platform.LocalWindowInfo
import androidx.compose.ui.unit.IntSize

@Composable
actual fun currentWindowSizePx(): IntSize = LocalWindowInfo.current.containerSize
